import { ButtonText } from 'shared/ui/buttons/buttonText';
import { PayloadAction } from '@reduxjs/toolkit';
import { withAsyncActionFeedback } from 'shared/ui/asyncAction';
import { FC } from 'react';

import { useModal } from 'shared/lib/modal';
import { Confirm } from 'shared/ui/confirm';
import { ButtonContained } from 'shared/ui/buttons/buttonContained';

import { useAppDispatch, useAppSelector } from 'shared/lib/store';
import {
	getOrdersByDateTime,
	markOrderVisitAsMissed,
	Order,
	useOrderInfo,
} from 'entities/orders';

import { selectSelectedTimeslot } from 'entities/toolbar/timeslots';
import { Filters } from 'shared/lib/pagination';
import { Flex } from 'shared/ui/flex';
import { ButtonOutlined } from 'shared/ui/buttons/buttonOutlined';

const ActionButtonContainedWithFeedback =
	withAsyncActionFeedback(ButtonContained);
const ActionButtonOutlinedWithFeedback =
	withAsyncActionFeedback(ButtonOutlined);

interface OrderDetailCancelConfirmProps {
	cancelBook: () => Promise<PayloadAction<unknown> | void>;
	onSuccessFetchData?: (filtersParam?: Filters) => void;
	order: Order;
}

export const OrderDetailCancelConfirm: FC<OrderDetailCancelConfirmProps> = ({
	cancelBook,
	onSuccessFetchData,
	order,
}) => {
	const { openModal, closeModal } = useModal();
	const dispatch = useAppDispatch();
	const { close } = useOrderInfo();
	const selectedTimeslot = useAppSelector(selectSelectedTimeslot);

	const handleSuccess = async () => {
		await close();
		if (selectedTimeslot) {
			dispatch(
				getOrdersByDateTime({
					status: 'appointed',
					dt_start: selectedTimeslot,
				}),
			);
		}
		closeModal();
		onSuccessFetchData?.();
	};

	const handleClick = async () => {
		return cancelBook();
	};

	const orderToVisitMissed = async () => {
		return await dispatch(markOrderVisitAsMissed({ id: order.id }));
	};

	return (
		<>
			<Confirm
				title={'Вы действительно хотите отменить бронирование?'}
				confirmButton={
					<Flex $direction="column" $gap="15px">
						<ActionButtonContainedWithFeedback
							onClick={orderToVisitMissed}
							onSuccess={handleSuccess}
							successToastLabel={`Отмена! Гость ${order?.person?.name} не пришёл!`}
						>
							Да, гость не пришёл
						</ActionButtonContainedWithFeedback>

						<ActionButtonOutlinedWithFeedback
							onClick={handleClick}
							onSuccess={handleSuccess}
							successToastLabel={`Отмена! Бронирование на имя ${order?.person?.name} удалено!`}
						>
							Да, удалить бронирование
						</ActionButtonOutlinedWithFeedback>
					</Flex>
				}
				cancelButtonLabel="Нет, оставить"
			/>
			<ButtonText color="danger" isFullWidth={true} onClick={openModal}>
				Отменить бронь
			</ButtonText>
		</>
	);
};
